<template>
    <div class="container">
        <SectionIntro
            class="mt-16"
            xl
            :title="$t('menu.editors')"
            :subtitle="$t('editor.index.subtitle')"
        />
        <div class="grid grid-cols-12 gap-y-8 lg:gap-x-8 lg:gap-y-12">
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    eager
                    :title="$t('editor.index.star_map_title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-6-b.webp')
                    "
                    slug="editors-star-map"
                    :subtitle="$t('editor.index.star_map_subtitle')"
                    wide
                />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    eager
                    :title="$t('editor.index.map_title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-7.webp')
                    "
                    slug="editors-map"
                    :subtitle="$t('editor.index.map_subtitle')"
                    wide
                />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    :title="$t('editor.wood_map.title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-7.webp')
                    "
                    slug="editors-wood-map"
                    :subtitle="$t('editor.index.wood_map_subtitle')"
                    wide
                />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    :title="$t('editor.wood_star_map.title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-6-b.webp')
                    "
                    slug="editors-wood-star-map"
                    :subtitle="$t('editor.index.wood_star_map_subtitle')"
                    wide
                />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    :title="$t('editor.topo_map.title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-7.webp')
                    "
                    slug="editors-topo-map"
                    :subtitle="$t('editor.index.topo_map_subtitle')"
                    wide
                />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <EditorPreviewCard
                    :title="$t('editor.city_map.title')"
                    :image="
                        require('~/assets/images/dev/product_category_previews/product_category_preview_image-7.webp')
                    "
                    slug="editors-city-map"
                    :subtitle="$t('editor.index.city_map_subtitle')"
                    wide
                />
            </div>
        </div>
    </div>
</template>

<script>
import EditorPreviewCard from '@/components/Cards/EditorPreviewCard/EditorPreviewCard.vue';
export default {
    name: 'Editors',
    components: {
        EditorPreviewCard,
    },
};
</script>
